/**
 * @generated SignedSource<<f17436b15e0de6b2b62c9f9cf6486777>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedContainer_similarLandingItems$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
  readonly " $fragmentType": "PdpRespCondensedContainer_similarLandingItems";
};
export type PdpRespCondensedContainer_similarLandingItems$key = {
  readonly " $data"?: PdpRespCondensedContainer_similarLandingItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_similarLandingItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedContainer_similarLandingItems",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_similarItems"
    }
  ],
  "type": "moreLikeThisItemConnection",
  "abstractKey": null
};

(node as any).hash = "b90a876d8db55ae22cb970183a9828cd";

export default node;
